exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1gSMArqiKBl92_SIGw1J-9 .step-container .creative-preview>.col{background:dycolor-internal(!creative-preview-background,@theme-light-grey)}._1gSMArqiKBl92_SIGw1J-9 .step-container .download-link{color:dycolor-internal(!download-link,@theme-black);background-color:dycolor-internal(!download-link-background,@primary)}._1gSMArqiKBl92_SIGw1J-9 .step-container .issue{background:dycolor-internal(!issue-background,@theme-error);color:dycolor-internal(!issue-font,@theme-white)}._1gSMArqiKBl92_SIGw1J-9 .setup-container{border-top:1px solid dycolor-internal(!description-bottom-border,@theme-dark-grey)}\n", ""]);

// exports
exports.locals = {
	"root": "_1gSMArqiKBl92_SIGw1J-9"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true!./~/gotu-vue-dycolor/dist/lib/dycolor-loader.js?colors!./~/sass-loader/lib/loader.js?outputStyle=compressed!./src/components/rabbit/campaign-step/CampaignStep.scss
// module id = 897
// module chunks = 1